/* eslint-disable import/no-unused-modules */
import { Stack as NovaStack } from '@fme-nova/components'
import { Stack as MuiBaseStack, StackProps } from '@mui/material'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

/** @component */
export const MuiStack: MsdkStyledComponent<StackProps> = styled(MuiBaseStack)``

export const Stack = createComponentWrapperWithRef<StackProps>(
  {
    mui: MuiStack,
    nova: NovaStack,
  },
  'Stack',
)
